import { useAuth } from "@/auth/AuthContext.jsx";
import { ROLES } from "@/utils/constants.js";
import { isStaffRole, STAFF_ROLE_LABELS } from "@/utils/staffAccess.js";
import "./admin-banner.css";

export default function AdminBanner() {
    const { isAuthenticated, role } = useAuth();

    if (!isAuthenticated || !isStaffRole(role)) {
        return null;
    }

    const label = STAFF_ROLE_LABELS[role] || "personnel";
    const asLabel = role === ROLES.ADMIN
        ? "qu'administrateur"
        : `que ${label.toLowerCase()}`;
    return (
        <div className="admin-banner-wrap" role="status" data-tour="admin-banner">
            Vous êtes connecté en tant {asLabel}.
        </div>
    );
}
